export enum SmsListStatus {
  WAITING = 'waiting',
  SENDING = 'sending',
  DONE = 'done',
}
